import React from "react";
import styles from "./Creators.module.css";
import { AiFillLinkedin, AiFillGithub, AiFillHtml5 } from "react-icons/ai";
import { DiCss3, DiJavascript } from "react-icons/di";
import { BsFillBootstrapFill, BsWindowDock } from "react-icons/bs";
import {
  FaReact,
  FaNodeJs,
  FaRegListAlt,
  FaDiscord,
  FaGithub,
} from "react-icons/fa";
import { TbBrandVercel } from "react-icons/tb";
import {
  SiSequelize,
  SiRedux,
  SiSupabase,
  SiMysql,
  SiExpress,
} from "react-icons/si";
import { IoIosCodeWorking } from "react-icons/io";
import "animate.css";
import guille from "../../img/guille.png";
import gaston from "../../img/gaston.png";
import lucas from "../../img/lucas.png";
import martin from "../../img/martin.png";
import cookies from "../../img/CookiesAbout.jpg";
import brownies from "../../img/BrowniesAbout.jpg";

function Creators() {
  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  return (
    <>
      <div className="d-flex flex-column mt-5">
        <div
          className={
            styles.imgsContainer +
            " d-flex flex-column justify-content-around w-100 animate__animated animate__fadeInDown"
          }
        >
          <div
            className={
              styles.creatorContainer +
              " container d-flex mt-5   justify-content-center"
            }
          >
            <div className="row justify-content-center">
              <div className="col-sm-12 col-md-6 col-lg-3">
                <div
                  className={
                    styles.imgContainer +
                    " d-flex flex-column m-1 w-100 align-items-center animate__animated animate__fadeInDown"
                  }
                >
                  <img src={lucas} alt="" />
                  <h3 className={styles.pictureName}>Lucas Baldomir</h3>
                  <h6 className={styles.fullStack}>Full Stack Developer Jr</h6>
                  <div className="d-flex">
                    <a
                      href="https://www.linkedin.com/in/lucas-baldomir-ferr%C3%A9s-a6529a193/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <AiFillLinkedin className={styles.icon} />
                    </a>
                    <a
                      href="https://github.com/lucasbaldomir"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <AiFillGithub className={styles.icon} />
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-3">
                <div
                  className={
                    styles.imgContainer +
                    " d-flex flex-column m-1 w-100 align-items-center animate__animated animate__fadeInDown"
                  }
                >
                  <img src={gaston} alt="" />
                  <h3 className={styles.pictureName + " text-center"}>
                    Gastón Hernández
                  </h3>
                  <h6 className={styles.fullStack}>Full Stack Developer Jr</h6>
                  <div className="d-flex">
                    <a
                      href="https://www.linkedin.com/in/aldo-hernandez-288134113/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <AiFillLinkedin className={styles.icon} />
                    </a>
                    <a
                      href="https://github.com/GasHer05"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <AiFillGithub className={styles.icon} />
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-3">
                <div
                  className={
                    styles.imgContainer +
                    " d-flex flex-column m-1 w-100 align-items-center animate__animated animate__fadeInDown"
                  }
                >
                  <img src={martin} alt="" />
                  <h3 className={styles.pictureName + " text-center"}>
                    Martín Hernández
                  </h3>
                  <h6 className={styles.fullStack}>Full Stack Developer Jr</h6>
                  <div className="d-flex">
                    <a
                      href="https://www.linkedin.com/in/martin-hernandez-uy/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <AiFillLinkedin className={styles.icon} />
                    </a>
                    <a
                      href="https://github.com/MartinHernandezUY"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <AiFillGithub className={styles.icon} />
                    </a>
                  </div>
                </div>
              </div>

              <div className=" col-sm-12 col-md-6 col-lg-3">
                <div
                  className={
                    styles.imgContainer +
                    " d-flex flex-column m-1 w-100 align-items-center animate__animated animate__fadeInDown"
                  }
                >
                  <img src={guille} alt="" />
                  <h3 className={styles.pictureName}>Guillermo Torres</h3>
                  <h6 className={styles.fullStack}>Full Stack Developer Jr</h6>
                  <div className="d-flex">
                    <a
                      href="https://www.linkedin.com/in/guillermo-torres-831b2b223"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <AiFillLinkedin className={styles.icon} />
                    </a>
                    <a
                      href="https://github.com/Guilleto98"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <AiFillGithub className={styles.icon} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.customShapeDivider}>
            <svg
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1200 120"
              preserveAspectRatio="none"
              fill="#1f2021e1"
            >
              <path
                d="M1200 120L0 16.48 0 0 1200 0 1200 120z"
                className={styles.shapeDivider}
              ></path>
            </svg>
          </div>
        </div>

        <div className={styles.aboutProyect + " container p-5"}>
          {/* Agregar más padding, 100px aprox*/}
          <div className="row row-eq-height justify-content-between">
            <div className={styles.grandCard + " col-12 col-lg-4"}>
              <div className={styles.cardIcon}>
                <BsWindowDock />
              </div>
              <div className={styles.cardAbout + " m-1 bg-light mb-5"}>
                <small
                  style={{ color: "#1f2021e1" }}
                  className="fw-bold fs-6 text-center"
                >
                  Introducción:{" "}
                </small>
                <p className="mt-2">
                  Este proyecto se desarrolló con fines académicos como trabajo
                  final del Coding Bootcamp-Grupo 2209 de Hack Academy,
                  institución educativa fundada en 2016 especializada en
                  programación. La consigna consistía en realizar en equipos de
                  4 integrantes, un e-commerce de temática libre con una
                  duración de 3 semanas.
                </p>
              </div>
            </div>
            <div className={styles.grandCard + " col-12 col-lg-4"}>
              <div className={styles.cardIcon}>
                <IoIosCodeWorking />
              </div>
              <div className={styles.cardAbout + " m-1 bg-light mb-5"}>
                <small
                  style={{ color: "#1f2021e1" }}
                  className="fw-bold fs-6 text-center"
                >
                  Desafíos:{" "}
                </small>
                <p className="mt-2">
                  El tiempo fue un factor determinante para la amplitud del
                  proyecto, presentándonos dificultades desde el primer momento
                  como definir las relaciones entre entidades en el diseño de
                  nuestro MER, y obligándonos a mantener una permanente
                  comunicación y organización para el logro de los objetivos.
                </p>
              </div>
            </div>

            <div className={styles.grandCard + " col-12 col-lg-4"}>
              <div className={styles.cardIcon}>
                <FaRegListAlt />
              </div>
              <div className={styles.cardAbout + " m-1 bg-light mb-5"}>
                <small
                  style={{ color: "#1f2021e1" }}
                  className="fw-bold fs-6 text-center"
                >
                  Organización:{" "}
                </small>
                <p className="mt-2">
                  Para el desarrollo utilizamos la metodología Scrum, basándonos
                  en los estándares MVP para llegar a presentar avances
                  semanales, demostrando la evolución del proyecto. Para ello
                  nos pusimos objetivos de corto plazo, apoyándonos en
                  herramientas como trello y manteniendo foco en el producto
                  final.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.aboutEcommerce + " container mb-5"}>
          <div className="row justify-content-center">
            <div className="col-8 pb-4 mb-3 align-items-center">
              <h3
                style={{ color: "#1f2021e1" }}
                className={styles.h3AboutThisProyect + " fs-3 text-center mb-3"}
              >
                E-commerce
              </h3>
              <p className="text-center">
                Este proyecto tuvo como objetivo poner en práctica todos los
                conocimientos adquiridos los últimos 3 meses y le dedicamos como
                grupo, más de 600hs en las últimas 3 semanas. El Bootcamp es un
                curso de tiempo completo que capacita a desarrolladores como
                Full Stack Jr.
              </p>
            </div>
          </div>
        </div>

        <h4 className="text-center fs-1 mb-3">Tecnologías y Herramientas</h4>
        <div className={styles.divTechnologies + " w-100 bg-light"}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div
                  className={
                    styles.technologys +
                    " col-6 w-100 p-3 m-1 animated__animated animate__bounceInRight"
                  }
                >
                  <div
                    className={
                      styles.technologiesText + " d-flex justify-content-around"
                    }
                  >
                    <div>
                      <p>
                        <SiMysql /> SQL
                      </p>
                      <p className="pTechnology">
                        <SiExpress /> Express.js
                      </p>
                      <p className="pTechnology">
                        <DiJavascript /> JavaScript
                      </p>
                    </div>
                    <div>
                      <p className="pTechnology">
                        <BsFillBootstrapFill /> Boostrap
                      </p>
                      <p className="pTechnology">
                        <FaReact /> React
                      </p>
                      <p className="pTechnology">
                        <FaNodeJs /> NodeJs
                      </p>
                    </div>
                    <div>
                      <p className="pTechnology">
                        <SiSequelize /> Sequelize
                      </p>
                      <p className="pTechnology">
                        <SiRedux /> Redux
                      </p>
                      <p className="pTechnology">
                        <SiSupabase /> Supabase
                      </p>
                    </div>
                    <div>
                      <p>
                        <TbBrandVercel /> Vercel
                      </p>
                      <p>
                        <FaDiscord /> Discord
                      </p>
                      <p>
                        <FaGithub /> Github
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mb-5">
          <div className="row">
            <div
              className={
                styles.divDesign +
                " col-12 col-lg-6 d-flex flex-column justify-content-center px-5 mb-5"
              }
            >
              <h3 className="text-center" style={{ color: "#1f2021e1" }}>
                Diseño
              </h3>
              <p className="text-start">
                Para la creación de nuestro E-commerce tomamos como inspiración
                un emprendimiento local de la ciudad de San José de Mayo.
                Utilizamos su paleta de colores pasteles y creamos una página
                versátil y minimalista, muy intuitiva y fácil de usar.
              </p>
            </div>
            <div className={styles.divImgFood + " col-12 col-lg-6 mb-5"}>
              <img src={cookies} className={styles.imgFood} alt="cookies" />
            </div>
            <div className={styles.divImgFood + " col-12 col-lg-6 mb-5"}>
              <img src={brownies} className={styles.imgFood} alt="cookies" />
            </div>
            <div className="col-12 col-lg-6 d-flex flex-column justify-content-center px-5 mb-5">
              <h3 style={{ color: "#1f2021e1" }} className="text-center">
                Funcionalidad
              </h3>
              <p className="text-start">
                El e-commerce cuenta con todas las funcionalidades básicas de un
                sitio de estas características, se puede acceder a los
                diferentes productos por su categoría desde el home gracias al
                filtro que realizamos, y también ver cada producto en su página
                individual haciendo click sobre el item deseado.
              </p>
            </div>
          </div>
        </div>

        <div className="w-100 bg-light mb-5">
          <div className={styles.containerAdmin + " container"}>
            <div className=" row justify-content-center">
              <div className={styles.adminDashboard + " col-10 col-lg-8 p-5"}>
                <h4 className="text-center fs-1 mb-3">
                  Funcionalidades administrativas
                </h4>
                <p className="text-center">
                  El proyecto cuenta también con un dashboard/panel de
                  administración del e-commerce. El usuario, con permisos de
                  administrador, puede realizar CRUD de usuarios, clientes,
                  categorías y productos, así como actualizar el status de las
                  órdenes. Para acceder al dashboard debe loguearse utilizando
                  como credenciales el email admin@prueba y la contraseña
                  "1234".
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Creators;
